import React from "react";

const Pagination = ({ totalPosts, postsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  const renderPages = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <li key={i}>
          <button
            className={i === currentPage ? "active" : ""}
            onClick={() => onPageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }
    return pages;
  };

  return (
    <div className="vs-pagination">
      <ul>
        {currentPage > 1 && (
          <li>
            <button onClick={() => onPageChange(currentPage - 1)}>
              <i className="far fa-arrow-left" />
            </button>
          </li>
        )}
        {renderPages()}
        {currentPage < totalPages && (
          <li>
            <button onClick={() => onPageChange(currentPage + 1)}>
              <i className="far fa-arrow-right" />
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Pagination;
